// Business Development: the route and the sidebar row of
// `wealth.intelligence.business-development` (ADR-0027).
//
// The page is an empty state: no source fills it yet. Dowgate staff see it
// today, so the Dowgate manifest turns the feature on.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.intelligence.business-development',
    routes: [
        {
            frontend: 'view',
            path: 'business-development',
            lazy: () => import('@/pages/view/business-development/page'),
        },
    ],
    nav: [
        {
            frontend: 'view',
            key: 'business-development',
            label: 'Business Development',
            href: '/view/business-development',
            icon: 'Rocket',
            group: 'intelligence',
            order: 340,
        },
    ],
});
